<button class="option-button" [ngClass]="option.isSelected === true ? 'selected' : ''" matRipple
    (click)="optionHandler(option)">
    {{option.optionName}}
  </button>
